import service from '@/plugins/service'
import { createFormData } from '@/plugins/formData'

const base = 'device'
const groupBase = 'device/group'
const t = 'device/tp/admin/expression'
const SIM = "device/smarthing/sim"

export const getDeviceAggregation = data => {
  return service({
    url: `${base}/point/aggregation`,
    method: 'POST',
    data
  })
}

export const generateDeviceCode = params => {
  return service({
    url: `${base}/generateDeviceCode`,
    method: 'GET',
    params
  })
}

export const getDeviceList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const searchDeviceList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const getDeviceStatus = id => {
  return service({
    url: `${groupBase}/device/status`,
    method: 'GET',
    params: {
      id
    }
  })
}

export const addDevice = data => {
  return service({
    url: `${base}`,
    method: 'post',
    data
  })
}

export const updateDevice = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const deleteDevice = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const getDeviceHistoryData = params => {
  return service({
    url: `${base}/history`,
    method: 'GET',
    params
  })
}

export const deleteDeviceHistoryData = params => {
  return service({
    url: `${base}/history`,
    method: 'DELETE',
    params
  })
}

export const getDeviceGroupList = (current, pageSize) => {
  return service({
    url: `${groupBase}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const searchGroupList = (current, pageSize, data) => {
  return service({
    url: `${groupBase}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addDeviceGroup = data => {
  return service({
    url: `${groupBase}`,
    method: 'POST',
    data
  })
}

export const updateDeviceGroup = data => {
  return service({
    url: `${groupBase}`,
    method: 'PUT',
    data
  })
}

export const getDeviceGroup = id => {
  return service({
    url: `${groupBase}`,
    method: 'GET',
    params: {
      id
    }
  })
}

export const getDevicesStatus = deviceGroupId => {
  return service({
    url: `${groupBase}/device/status`,
    method: 'GET',
    params: {
      deviceGroupId
    }
  })
}

export const removeDeviceGroup = id => {
  return service({
    url: `${groupBase}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const getDayReport = (date, deviceCode, flowPowerEnabled = false) => {
  return service({
    url: `${groupBase}/stats/day`,
    method: 'GET',
    params: {
      deviceCode,
      date,
      flowPowerEnabled
    }
  })
}

export const getMonthReport = (startDate, endDate, deviceCode, flowPowerEnabled = false) => {
  return service({
    url: `${groupBase}/stats/month`,
    method: 'GET',
    params: {
      startDate,
      endDate,
      deviceCode,
      flowPowerEnabled
    }
  })
}

export const getYearReport = (startDate, endDate, deviceCode, flowPowerEnabled = false) => {
  return service({
    url: `${groupBase}/stats/year`,
    method: 'GET',
    params: {
      startDate,
      endDate,
      deviceCode,
      flowPowerEnabled
    }
  })
}

export const exportReport = (params) => {
  return service({
    url: `${groupBase}/stats/export`,
    method: 'GET',
    params,
    responseType: 'blob'
  })
}

export const exportReportM = (params) => {
  return service({
    url: `${groupBase}/stats/month/export`,
    method: 'GET',
    params,
    responseType: 'blob'
  })
}

export const exportReportY = (params) => {
  return service({
    url: `${groupBase}/stats/year/export`,
    method: 'GET',
    params,
    responseType: 'blob'
  })
}

export const getResourceTypeList = (current, pageSize, data) => {
  return service({
    url: `${groupBase}/resource/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const deleteSource = id => {
  return service({
    url: `${groupBase}/resource`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const addSource = data => {
  const formData = new FormData()
  for (let i in data) {
    formData.append(i, data[i])
  }

  return service({
    url: `${groupBase}/resource`,
    method: 'POST',
    data: formData
  })
}

export const uploadSource = data => {
  return service({
    url: `${groupBase}/resource`,
    method: 'PUT',
    data
  })
}

export const getResourceList = () => {
  return service({
    url: `${groupBase}/resource`,
    method: 'GET'
  })
}

export const getRunningData = params => {
  return service({
    url: `${base}/runningData`,
    method: 'GET',
    params
  })
}

export const exportRunningData = params => {
  return service({
    url: `${base}/runningData/export`,
    method: 'GET',
    params,
    responseType:'blob'
  })
}

export const reStart = dtuCode => {
  const data = new FormData()
  data.append('dtuCode', dtuCode)

  return service({
    url: `${base}/dtu/restart`,
    method: 'post',
    data
  })
}

export const getExpression = groupId => {
  return service({
    url: `${t}`,
    method: 'GET',
    params: {
      groupId
    }
  })
}

export const addExpression = data => {
  return service({
    url: `${t}`,
    method: 'POST',
    data
  })
}

export const updateExpression = data => {
  return service({
    url: `${t}`,
    method: 'PUT',
    data
  })
}

export const deletExpression = id => {
  return service({
    url: `${t}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const writeCommand = o =>  {
  const data = createFormData(o)

  return service({
    url: `${base}/write/command`,
    method: 'post',
    data
  })
}

export const exportDevice = data => {
  return service({
    url: `${base}/list/export`,
    method: 'POST',
    data,
    responseType: 'blob'
  })
}

export const getVincinity = deviceCode => {
  return service({
    url: `${base}/position/vicinity`,
    method: 'GET',
    params: {
      deviceCode,
      lng: '',
      lat: '',
      distance: '',
      company: ''
    }
  })
}

export const refreshPosition = deviceCode => {
  return service({
    url: `${base}/position/refresh`,
    method: 'GET',
    params: {
      deviceCode
    }
  })
}

export const switchDevice = o => {
  const data = createFormData(o)

  return service({
    url: `${base}/switch`,
    method: 'POST',
    data
  })
}

export const writeValue = o => {
  const data = createFormData(o)

  return service({
    url: `${base}/write/value`,
    method: 'POST',
    data
  })
}

export const getUnRemovedDTUList = () => {
  return service({
    url: `${base}/notRemovedDTU`,
    method: 'GET'
  })
}

export const getMultiAggregation = data => {
  return service({
    url: `${base}/point/multi/aggregation`,
    method: 'POST',
    data
  })
}

export const getDevicePositionHistory = params => service({
  url: `${base}/position/history`,
  method: 'GET',
  params
})

export const queryDevicePositionHistory = (current, pageSize, data) => service({
  url: `${base}/position/history/query`,
  method: 'POST',
  params: {
    current,
    pageSize
  },
  data
})

export const getMaintainDataList = (startTime, endTime, current, pageSize, data) => service({
  url: `${base}/maintainData`,
  method: 'POST',
  params: {
    startTime,
    endTime,
    current,
    pageSize
  },
  data
})

export const getExportUid = (startTime, endTime, data) => service({
  url: `${base}/maintainData/export`,
  method: 'POST',
  params: {
    startTime,
    endTime
  },
  data
})

export const exportMaintainDataFile = uid => service({
  url: `${base}/maintainData/download`,
  method: 'GET',
  params: {
    uid
  },
  responseType:'blob'
})

export const insertSelfDefinedExpression = data => service({
  url: `${base}/tp/admin/custom/expression`,
  method: 'POST',
  data
})

export const updateSelfDefinedExpression = data => service({
  url: `${base}/tp/admin/custom/expression`,
  method: 'PUT',
  data
})

export const getSelfDefinedExpression = groupId => service({
  url: `${base}/tp/admin/custom/expression`,
  method: 'GET',
  params: {
    groupId
  }
})

export const deleteSelfDefinedExpression = id => service({
  url: `${base}/tp/admin/custom/expression`,
  method: 'DELETE',
  params: {
    id
  }
})

export const postUnRegCustomer = time => {
  const data = createFormData({ time })

  return service({
    url: `${base}/unRegCustomer`,
    method: 'POST',
    data
  })
}

export const getSIMs = (current, pageSize, data) => service({
  url: `${SIM}/query`,
  method: "POST",
  params: {
    current,
    pageSize
  },
  data
})

export const activateSIM = giccid => service({
  url: `${SIM}/activate`,
  method: "POST",
  params: {
    giccid
  }
})

export const deactivateSIM = giccid => service({
  url: `${SIM}/deactivate`,
  method: "POST",
  params: {
    giccid
  }
})

export const retireSIM = giccid => service({
  url: `${SIM}/retire`,
  method: "POST",
  params: {
    giccid
  }
})

export const exportSIM = data => service({
  url: `${SIM}/export`,
  method: "POST",
  data,
  responseType:'blob'
})

export const generateDeviceGroupCode = () => service({
  url: `${groupBase}/generateDeviceGroupCode`,
  method: "GET"
})

export const exportNewReportByDay = (deviceCode, startDate) => service({
  url: 'device/group/stats/data/day/export',
  method: "GET",
  params: {
    deviceCode,
    startDate
  },
  responseType: "blob"
})

export const exportNewReportByMonth = (deviceCode, startDate, endDate) => service({
  url: 'device/group/stats/data/month/export',
  method: "GET",
  params: {
    deviceCode,
    startDate,
    endDate
  },
  responseType: "blob"
})

export const exportNewReportByYear = (deviceCode, startDate, endDate) => service({
  url: 'device/group/stats/data/year/export',
  method: "GET",
  params: {
    deviceCode,
    startDate,
    endDate
  },
  responseType: "blob"
})

export const syncDtu = dtuCode => service({
  url: "/device/smarthing/sim/sync_dtu",
  method: "GET",
  params: {
    dtuCode
  }
})

export const getAggregateHistoryData = params => service({
  url: `${base}/aggregate/historyData`,
  method: "GET",
  params
})

export const putModifyParameter = (modify, deviceCode) => service({
  url: `${base}/modify/parameter`,
  method: "PUT",
  params: {
    modify,
    deviceCode
  }
})

export const getNXFXYDayReportData = (deviceCodes, date, unit) => service({
  url: `${base}/energyEfficiency/analysis/day`,
  method: "GET",
  params: {
    deviceCodes,
    date,
    unit
  }
})

export const getNXFXYMonthReportData = (deviceCodes, startDate, endDate, unit) => service({
  url: `${base}/energyEfficiency/analysis/month`,
  method: "GET",
  params: {
    deviceCodes,
    startDate,
    endDate,
    unit
  }
})

export const getNXFXYYearReportData = (deviceCodes, startDate, endDate, unit) => service({
  url: `${base}/energyEfficiency/analysis/year`,
  method: "GET",
  params: {
    deviceCodes,
    startDate,
    endDate,
    unit
  }
})

export const exportNXFXYDayReportData = (deviceCodes, startDate, endDate, unit) => service({
  url: `${base}/energyEfficiency/analysis/day/export`,
  method: "GET",
  params: {
    deviceCodes,
    startDate,
    endDate,
    unit
  },
  responseType: "blob"
})

export const exportNXFXYMonthReportData = (deviceCodes, startDate, endDate, unit) => service({
  url: `${base}/energyEfficiency/analysis/month/export`,
  method: "GET",
  params: {
    deviceCodes,
    startDate,
    endDate,
    unit
  },
  responseType: "blob"
})

export const exportNXFXYYearReportData = (deviceCodes, startDate, endDate, unit) => service({
  url: `${base}/energyEfficiency/analysis/year/export`,
  method: "GET",
  params: {
    deviceCodes,
    startDate,
    endDate,
    unit
  },
  responseType: "blob"
})